import jwtDefaultConfig from './jwtDefaultConfig'
import { isExternalAccess } from '@/auth/utils'

export default class JwtService {
  // Will be used by this service for making API calls
  axiosIns = null

  // jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // For Refreshing Token
  subscribers = []

  constructor(axiosIns, jwtOverrideConfig, router) {
    this.axiosIns = axiosIns
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    // Request Interceptor
    this.axiosIns.interceptors.request.use(
      config => {
        // Get token from localStorage
        const accessToken = this.getToken()

        // If token is present add it to request's Authorization Header
        if (accessToken) {
          // eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
        }
        return config
      },
      error => Promise.reject(error),
    )

    this.axiosIns.interceptors.response.use(
      response => response,
      error => {
        // const { response: { status } } = error
        // const { config, response } = error
        // const originalRequest = config

        if (error.response.status === 401) {
          if (isExternalAccess()) {
            router.push('/portal-cliente/login')
          } else {
            router.push('/login')
          }
        }
        if (error.response.status === 403) {
          // eslint-disable-next-line no-param-reassign
          error.response.statusText = 'Não possui permissão para realizar essa ação!'
        }
        return Promise.reject(error)
      },
    )
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter(callback => callback(accessToken))
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName)
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  login(...args) {
    localStorage.clear()
    return this.axiosIns.post(this.jwtConfig.loginEndpoint, ...args)
  }

  getClientGoogle() {
    return this.axiosIns.get(this.jwtConfig.getClientGoogleEndpoint)
  }

  loginGoogle(token) {
    localStorage.clear()
    return this.axiosIns.post(
      this.jwtConfig.loginGoogleEndpoint,
      JSON.stringify(token),
      { headers: { 'Content-Type': 'application/json' } },
    )
  }

  alterarSenha(...args) {
    return this.axiosIns.post(this.jwtConfig.alterarSenhaEndpoint, ...args)
  }

  esqueciSenha(...args) {
    return this.axiosIns.put(`${this.jwtConfig.forgotPasswordEndpoint}?email=${args}`)
  }

  register(...args) {
    return this.axiosIns.post(this.jwtConfig.registerEndpoint, ...args)
  }

  confirmarAcesso(...args) {
    return this.axiosIns.post(this.jwtConfig.confirmAccessEndpoint, ...args)
  }

  refreshToken() {
    return this.axiosIns.post(this.jwtConfig.refreshEndpoint, {
      refreshToken: this.getRefreshToken(),
    })
  }
}
